import { Constants } from '../../shared/Constants.js';
import { Utils } from '../../shared/Utils.js';

/**
 * Month grid rendering.
 */
export function renderMonths(picker) {
  const $ = window.jQuery;
  const GDT = window.GenericDateTime;
  const $grid = $('<div class="gdp-months-grid"></div>');
  const months = Utils.getMonthNames('short', picker.config.locale);

  months.forEach((name, i) => {
    const year = picker.state.viewDate.getFullYear();
    const isSelected =
      i === picker.state.currentDate.getMonth() && year === picker.state.currentDate.getFullYear();

    let isFiltered = picker.config.filters.month && !picker.config.filters.month(i, year);

    if (picker.config.min) {
      const minDate = GDT.from(picker.config.min).startOf('month');
      const curMonth = GDT.from(new Date(year, i, 1));
      if (curMonth.isBefore(minDate, 'month')) isFiltered = true;
    }
    if (picker.config.max) {
      const maxDate = GDT.from(picker.config.max).startOf('month');
      const curMonth = GDT.from(new Date(year, i, 1));
      if (curMonth.isAfter(maxDate, 'month')) isFiltered = true;
    }

    const $month = $(
      `<div class="gdp-month-item ${isSelected ? 'selected' : ''} ${isFiltered ? 'disabled' : ''}">${name}</div>`,
    );

    if (!isFiltered) {
      $month.on('click', () => {
        picker.state.viewDate.setMonth(i);
        if (picker.config.components.date) {
          picker.state.view = Constants.Views.DAYS;
          picker._updateContent();
        } else {
          picker.state.currentDate.setFullYear(picker.state.viewDate.getFullYear(), i);
          picker._selectDate();
        }
      });
    }
    $grid.append($month);
  });

  return $grid;
}
